export default __webpack_public_path__ + "static/media/preset.64213232.txt";